<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
import './assets/css/global.css'
import './assets/css/style.css'
import './assets/css/new-global.css'
// import API from './services/api'




export default {

  // updated: function() {
  //   const token = localStorage.getItem('jwtToken'),
  //    res = API.post('/usuario/termoaceite/mensagemusuario', {token: token, origem: 2}).then((res)=> {
  //      if(res.data.sucesso == 2){
  //        this.$refs["confirmaSemDadosBancarios"].show();
  //      }
  //   })
  // }
}
</script>

<style>
@font-face {
  font-family: "Open Sans";
  src: url("~@/assets/fonts/OpenSans-Light.ttf");
}
@font-face {
  font-family: "Open Sans Bold";
  src: url("~@/assets/fonts/OpenSans-Bold.ttf");
}
@font-face {
  font-family: "Open Sans Italic";
  src: url("~@/assets/fonts/OpenSans-Italic.ttf");
}
@font-face {
  font-family: "TimeBurner Bold";
  src: url("~@/assets/fonts/timeburnerbold.ttf");
}
@font-face {
  font-family: "TimeBurner Regular";
  src: url("~@/assets/fonts/timeburnernormal.ttf");
}
@font-face {
  font-family: "Roboto Regular";
  src: url("~@/assets/fonts/Roboto-Regular.ttf");
}
@font-face {
  font-family: "Roboto Bold";
  src: url("~@/assets/fonts/Roboto-Bold_0.ttf");
}
/* @font-face{
  font-family: 'Kanit', sans-serif;
  src: url("~@/assets/fonts/Roboto-Bold_0.ttf");
} */
@font-face {
  font-family: "Source Sans";
  src: url("~@/assets/fonts/SourceSansPro-Semibold.ttf");
}

/* Melhoria */
@import url('https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Chivo:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://fonts.cdnfonts.com/css/rawline');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css');
 @font-face {
      font-family: allerbold;
      src: url("~@/assets/fonts/aller/aller_bd-webfont.woff2")format("woff2"), url("~@/assets/fonts/aller//aller_bd-webfont.woff") format("woff");
      font-weight: 400;
      font-style: normal;
  }
  @font-face {
      font-family: allerregular;
      src: url("~@/assets/fonts/aller/aller_rg-webfont.woff2")format("woff2"), url("~@/assets/fonts/aller//aller_rg-webfont.woff") format("woff");
      font-weight: 400;
      font-style: normal;
  }


@font-face {
  font-family: "Source Sans";
  src: url("~@/assets/fonts/SourceSansPro-Semibold.ttf");
}
@font-face {
  font-family: "Source Sans";
  src: url("~@/assets/fonts/SourceSansPro-Semibold.ttf");
}
/* * {
    font-family: "TimeBurner Bold" !important;

} */

:root {
  --main-azul: #209CEE;
  --main-bg-cinza: rgb(255, 251, 251);
  --main-azul-ciano: #41bfe3;
  --main-azul-botao: #06a6d4;
  --primary-color: #5CB3FF;
  --secondary-color: #454F57;
  --light-gray-color: #EFF2F5;
  --dark-gray-color: #BECAD5;
  --navbar-gray-color: #323739;
  --input-field-gray-color: #293033;
  --font-family: "Kanit", sans-serif;
}

/* MODIFICADORES DO VUE BOOTSTRAP */
label,
p{
  color:var(--secondary-color) !important;
  font-family: var(--font-family) !important;
  font-size: 15px;
  line-height: 27px;
  font-weight: 300;
  letter-spacing: -1%;
}
h1{
  color:var(--secondary-color) !important;
  font-family: var(--font-family) !important;
  font-size: 51px;
  line-height: 55px;
  font-weight: 400;
  letter-spacing: -1%;
}
h2{
  color:var(--secondary-color) !important;
  font-family: var(--font-family) !important;
  font-size: 44px;
  /* line-height: 77px; */
  font-weight:200;
  letter-spacing: -1%;
}
h3{
  color:var(--primary-color) !important;
  font-family: var(--font-family) !important;
  font-size: 24px;
  line-height: 37px;
  font-weight:500;
  letter-spacing: -1%;
}
.btn-primary {
  background-color: var(--primary-color) !important;
  color: #FFFFFFFF;
  padding: 0 33px;
  height: 49px;
  border-radius: 42px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Kanit', sans-serif;
  font-weight: 400;
  font-size: 20px;
  border: none;
  outline: none;
}
label,
text-primary,
p.text-primary,
h1.text-primary,
h2.text-primary,
h3.text-primary,
h4.text-primary {
  /* color: #597EB5 !important; */
  color:var(--secondary-color) !important;
  font-family: var(--font-family) !important;
}
.blue {
  /* font-family: 'Kanit', sans-serif; */
  /* color: #597EB5 !important; */
  font-family: var(--font-family) !important;
  color: var(--primary-color) !important;
}
.bold {
  /* font-family: "Kanit", sans-serif !important; */
  font-family: var(--font-family) !important;
}
.link {
  cursor: pointer;
  /* color: #004E86 !important; */
  color: var(--primary-color) !important;
}
.link:hover {
  opacity: 0.7;
}
/* remove botão cancel do MODAL */
footer.modal-footer button.btn.btn-secondary {
  display: none;
}


.slide-content-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

.table.b-table.small tbody tr td {
  font: normal normal normal 15px/20px 'Kanit', sans-serif !important;
  height: 48px;
  padding: 0;
  vertical-align: middle;
  color: #597EB5;
}
.table.b-table.small tbody tr td:first-child{
  padding-left: 20px;
}

input[type=checkbox] {
  cursor: pointer;
}

.table thead th {
  background-color: #597eb5 !important;
  color: white !important;
  font-weight: bold !important;
  background-color: #597EB5 !important;
  padding: 0 !important;
  height: 48px;
}
.table thead th:first-child{
  padding-left: 20px !important;
}
.table thead th div{
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  height: 48px;
  display: flex;
  align-items: center;
}
#resultados .table thead th:nth-child(1){min-width: 400px;}
#resultados .table thead th:nth-child(2){min-width: 90px;}
#resultados .table thead th:nth-child(3){min-width: 120px;}
#resultados .table thead th:nth-child(4){min-width: 165px;}
#resultados .table thead th:nth-child(5){min-width: 120px;}
#resultados .table tbody tr td:nth-child(1) div {
  max-width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  height: 20px;
  margin: 14.5px 0;
}

.table tbody tr td div {
  font: normal normal normal 15px/20px 'Kanit', sans-serif !important;
  color: #597EB5 !important;
  padding: 0px !important;
  height: 48px;
  display: flex;
  align-items: center;
  
}

.table tbody tr td div a {
  border-bottom: none !important;
  font-size: 12px !important;
  color: #736d6d !important;
}

/* usado para novo layout*/
div .border-primary-ieptb {
    border: none !important;
}

div .border-primary {
    border: none !important;
}

.card .shadow .card-body{
  border: none !important;
}

.card-header:first-child {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0 !important;
    font-size: 1.5rem !important;
}

span svg {
  color: var(--secondary-color) !important;
}

.text-primary-ieptb {
  color: var(--secondary-color) !important;
  background-color:transparent !important
}


.card-ieptb {
  color: #597EB5 !important;
}

.card-ieptb > .card-body {
  border: none;
  border-radius: 40px;
  box-shadow: 4px 4px 50px 0 #D1DBE2;
}
.card-protesto{
  margin-bottom: 50px;
}


.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    background: var(--primary-color) 0% 0% no-repeat padding-box !important;
}

.ul-ieptb .nav-tabs .nav-link {
  color: #fff !important;
  border-radius: 50% !important;
  border: none !important;
  width: 40px !important;
  height: 40px !important;
  padding-top: 10px !important;
  padding-left: 12px !important;
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  font: normal normal 200 16px/20px 'Kanit' !important;
  content: '';
  background-color: var(--secondary-color);
  position: relative;
}

.ul-ieptb > div > ul > li:not(:last-child)::after {
  content: '';
  width: 62px;
  height: 1px;
  background-color: var(--secondary-color);
  display: flex;
  bottom: 17.5px;
  position: relative;
  left: 40px;
}

.ul-ieptb > div > ul > li {
  padding: 19px; 
}

.conferencia_dados_label{
  color: #000 !important;
  border: none !important;
  float: left !important;
  margin-top: 8px !important;
}

.nav-link-ieptb {
  pointer-events: none !important;
  cursor: default !important;
  text-decoration: none !important;
  color: black !important;
}

.nav-tabs {
  border: none !important;
}

.exibirResultado {
  padding-left: 10px;
  border-width: 1px;
  border-style: solid;
  border-color: #B0AAAA;
  list-style-type: none; 
  width: fit-content;
  padding-right: 10px;
  color: #847d7d;
  border-radius: 6px;
  float: left;
  margin-left: 10px;
  margin-bottom: 10px;
}

.card-ieptb > .card-body > .card-text > .row > div >  label {
  font-weight: bold;
}

.card-ieptb > .card-body > .card-text > .row > div > div > label {
  /* font-weight: bold; */
}


/* fim usado para novo layout*/
@media (max-width:1199px) {
  #resultados .table thead th:nth-child(1){min-width:unset;}
  #resultados .table thead th:nth-child(2){min-width:110px;}
  #resultados .table tbody tr td:first-child{padding-right: 10px;}
}
</style>
